<template>
  <div v-loading="true" class="homeMiddleware"></div>
</template>

<script>
  import { navInfoAjax } from '@/services/commonApi';

  import { createNamespacedHelpers } from "vuex";

  const { mapActions } = createNamespacedHelpers("ws");

  export default {
    name: "homeMiddleware",
    data() {
      return {
        CAS_ENABLE: CAS_ENABLE,
      }
    },
    async mounted(){
      let self = this;
      // 如果启用了单点登录
      let userInfo = localStorage.getItem('userInfo');
      if (this.CAS_ENABLE && !userInfo) {
        await self.$store.dispatch("layout/userInfo").then(resp => {
          if (!!resp && resp.status === 200 && resp.success) {
            let result = resp.result;
            let companyCode = result.lastSelectCompany.code;
            localStorage.setItem("myUser", JSON.stringify(result));
            localStorage.setItem("userInfo", JSON.stringify(result));
            localStorage.setItem("sourceAppid", result.sourceAppid);
            localStorage.setItem("companyCode", result.lastSelectCompany.code); // 公司编码
            localStorage.setItem("myCompanyCode", result.lastSelectCompany.code); // 公司编码
            self.$store.dispatch("layout/navInfo", companyCode);
            self.UPDATE_LOGIN_INFO(result);
            //获取系统最高权限
            // self.$store.dispatch("layout/rootLevelInfo");
            self.bus.$emit('changeTeam', companyCode);
          }
        });
      }
      const resp = await navInfoAjax({companyCode: localStorage.myCompanyCode});

      if ((resp.status) === 200 && (resp.success)) {
        // 是否含有入库审核记录的
        if (haveCorpusAuditRecords) {
          let corpusIndex = resp.result.findIndex(item => item.code === 'trans_memory');
          // 如果存在语料库模块
          if (corpusIndex > -1) {
            // 获取语料库模块
            let corpusChildren = resp.result.find(item => item.code === 'trans_memory').children;
            corpusChildren.forEach(item => {
              if (item.code === 'memory_lib') {
                item.url = '/home/corpus/memoryLib';
              } else if (item.code === 'term_lib') {
                item.url = '/home/corpus/termLib';
              }
            });
            corpusChildren.push({
              children: null,
              code: "audit_records",
              icon: "auditRecordsIcon",
              id: 8,
              name: "入库审核记录",
              nameEn: "Audit records",
              remark: "",
              showChild: 0,
              sort: 33,
              tagId: "",
              url: "/home/corpus/warehousingAudit",
            });
            resp.result[corpusIndex].children = corpusChildren;
          }
        }
        this.$router.push({path: resp.result[0].url});
        if (resp.result[0].url === '') {
          this.$router.push({path: resp.result[0].children[0].url});
        } else {
          this.$router.push({path: resp.result[0].url});
        }
      } else {
        this.$router.push({path: "/home/projectHome",})
      }
    },
    methods: {
      ...mapActions(["UPDATE_LOGIN_INFO"]),
    }
  }
</script>

<style lang="less" scoped>
.homeMiddleware {
  height: 100%;
}
</style>